import React, { useState } from "react";
import { Modal, notification } from "antd";
import UploadBox from "../../components/UploadBox";
import InputBox from "../../components/InputBox";

const openNotification = () => {
  notification.success({
    message: "Success!",
    description: "GRN Number Added!!!",
    onClick: () => {
      console.log("Notification Clicked!");
    },
  });
};

const AddGRNForm = ({ visible, setVisible, onSave, orderId }) => {
  const [grnNumber, setGrnNumber] = useState("");
  const [grnFile, setGrnFile] = useState(null);
  const [displayError, setDisplayError] = useState(false);
  const [grnFileError, setGrnFileError] = useState(null);
  const [fileSizeError, setFileSizeError] = useState(false);

  const handleSuccess = () => {
    setVisible(false);
    setGrnNumber("");
    setGrnFile("");
    openNotification();
    setDisplayError(false);
    setFileSizeError(false);
  };

  const handleFailure = () => {
    console.log("An error occured");
    setDisplayError(false);
    setVisible(false);
    setGrnNumber("");
    setGrnFile("");
    setGrnFileError(null);
    setFileSizeError(false);
  };

  const handleFileUpload = (e) => {
    if (e?.target?.files[0]?.type !== "application/pdf") {
      setGrnFileError(true);
      setGrnFile(null);
      return;
    }
    if (e.target.files[0]?.size > 12 * 1024 * 1024) {
      setFileSizeError(true);
      return;
    }
    setGrnFileError(null);
    setGrnFile(null);
    const files = e.target.files;
    if (files.length) {
      const fileToUpload = files[0];
      setGrnFile(fileToUpload);
    }
  };

  const onSubmit = () => {
    if (!grnNumber || !grnFile) setDisplayError(true);
    else setDisplayError(false);
    const payloadData = {
      grnNumber,
      grnFile,
    };

    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };

    onSave(payload);
  };

  const handleCancel = () => {
    setGrnNumber("");
    setVisible(false);
    setDisplayError(false);
    setGrnFile(null);
    setGrnFileError(null);
    setFileSizeError(false);
  };

  return (
    <Modal
      title={`Add GRN`}
      visible={visible}
      okText="Submit"
      okButtonProps={{
        disabled:
          !grnNumber || !grnFile || grnNumber.trim().length === 0
            ? true
            : false,
      }}
      onOk={onSubmit}
      onCancel={handleCancel}
    >
      <InputBox
        value={grnNumber}
        onChange={(e) => {
          if (e.target.value.trim().length === e.target.value.length) {
            setGrnNumber(e.target.value);
          }
        }}
        label="Enter GRN Number"
      />
      <UploadBox
        value={grnFile}
        onChange={(e) => handleFileUpload(e)}
        label="Upload GRN File"
      />
      {grnFileError && (
        <p
          style={{
            color: "red",
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          Please upload .pdf files only
        </p>
      )}
      {fileSizeError && (
        <p
          style={{
            color: "#ff4d4f",
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          Size of the file exceeds 12 MB. Please try to upload file size less
          than 12 MB
        </p>
      )}
      {displayError && <p style={{ color: "red" }}>Field can't be empty</p>}
      <p
        style={{
          marginTop: "10px",
          color: "#75797d",
          fontSize: "12px",
          fontStyle: "italic",
        }}
      >
        * Uploaded file size should not exceed more than 12 MB
      </p>
    </Modal>
  );
};

export default AddGRNForm;
